import styled, { keyframes } from 'styled-components';

const bounce = keyframes`
  0%, 100% {
    transform: translateY(0) scaleY(1);
  }
  50% {
    transform: translateY(-4px) scaleY(1.1);
  }
`;

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
`;

export const IconWrapper = styled.div`
  position: relative;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => (theme.mode === 'dark'
    ? 'linear-gradient(135deg, #374151 0%, #1f2937 100%)'
    : 'linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%)')};
  border-radius: 50%;
  animation: ${pulse} 2s ease-in-out infinite;
`;

export const BarsContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 4px;
  height: 32px;
`;

export const Bar = styled.div<{ $delay: number; $height: number }>`
  width: 6px;
  height: ${(props) => props.$height}px;
  background: linear-gradient(180deg, #1a4d4d 0%, #0f3333 100%);
  border-radius: 6px;
  animation: ${bounce} 1s ease-in-out infinite;
  animation-delay: ${(props) => props.$delay}s;
`;

export const SpinningRing = styled.div`
  position: absolute;
  width: 88px;
  height: 88px;
  border: 3px solid transparent;
  border-top-color: #1a4d4d;
  border-right-color: #1a4d4d;
  border-radius: 50%;
  animation: ${rotate} 1.5s linear infinite;
`;
